import { Path } from '@/main/router/routerPath';

import { CRUMB_LABEL_KEY, NAME } from './constants';
import Edit from './Edit.vue';
import List from './List.vue';
import { AkcniProdejNdPolozky } from './polozky';

export const router = new Path().addChildren([
	new Path(NAME, { List, Edit }, CRUMB_LABEL_KEY),

	AkcniProdejNdPolozky.router,
]);
